var footerTheme = {
  footer: {
    defaultFooter: {
      backgroundStart: '#e6e6e6',
      backgroundEnd: '#e6e6e6',
      dividerColor: '#cfcfcf'
    }
  }
};
export default footerTheme;